export default "__VITE_ASSET__C0iqRh0E__"